import { StyleSheet } from 'react-native';
import { Colors } from '../themes/colors';
import { Spacing } from '.';
import { tokens } from '../components/crop-circle/tokens';

export const formStyles = StyleSheet.create({
  formItem: {
    paddingHorizontal: Spacing.basePadding.paddingHorizontal,
    paddingVertical: Spacing.smallPadding.paddingVertical,
    backgroundColor: Colors.role.surface,
    marginBottom: 4,
  },
  // Both titles need an explicit colour. A react-native-web <Text> whose style
  // omits `color` keeps the library's base class, which hardcodes black, so an
  // unset colour is not "inherit the theme" - it is literally black.
  formItemTitle: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    marginBottom: 8,
    color: Colors.role.textStrong,
  },
  formItemTitleCropCircle: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    marginBottom: 4,
    color: Colors.role.textStrong,
  },
});
